import { useEffect, useState } from 'react';

import { ResultStatus } from './constants';
import { ErrorView } from './error-view';
import { LoadingView } from './loading-view';
import { useSubsidyCalculator } from './provider';
import { submitAnswers } from './submit-answers';
import { SuccessView } from './success-view';
import { useComponentImpression } from './use-component-impression';

export function ResultsStep() {
  const [status, setStatus] = useState<ResultStatus>('idle');
  const { answers, setSubsidy } = useSubsidyCalculator();
  useComponentImpression(`subsidy-calculator-result-view-${status}`);

  const MIN_LOADING_TIME_MS = 5000;

  // Comment to ask for email before loading results
  useEffect(() => {
    submitAnswers({
      answers,
      setSubsidy,
      setStatus,
      minLoadingTime: MIN_LOADING_TIME_MS,
    });
  }, [answers, setStatus, setSubsidy]);

  // Uncomment to ask for email before loading results
  // if (status === 'idle') {
  //   return (
  //     <EmailView minLoadingTime={MIN_LOADING_TIME_MS} setStatus={setStatus} />
  //   );
  // }

  if (status === 'loading') {
    return <LoadingView minLoadingTime={MIN_LOADING_TIME_MS} />;
  }

  if (status === 'success') {
    return <SuccessView />;
  }

  if (status === 'error') {
    return <ErrorView />;
  }
}
